<template>
	<div>
		<el-row style="padding: 10px;">
			<el-col :span="21" style="padding-right: 1%;">
				<el-input style="width: 100%;" v-model="input"></el-input>
			</el-col>
			<el-col :span="3" style="padding-left: 1%;">
				<el-button style="width: 100%; border-color: #006E48; background-color: #006E48; color: #FFFFFF;" @click="query">查询</el-button>
			</el-col>
		</el-row>
		<div style="height: 550px; overflow-y:scroll; width: 100%; border-top: 1px solid #EBEEF5;;">
			<el-tree class="filter-tree" :props="defaultProps" lazy :load="loadNode" :filter-node-method="filterNode"
				ref="tree" :highlight-current="true" :accordion="accordion" @node-click="nodeSelection">
				<div slot-scope="{ node, data }">
					<div style="display: inline-block; width: 100%;">
						<el-divider content-position="left">{{data.organize_name}}</el-divider>
						<el-radio-group v-model="staff_id" v-if="type == 'radio'"
							@change="handleRadioChange(data.staffList)">
							<el-row style="width: 100%; margin-top: 10px;">
								<el-col :span="6" v-for="staff in data.staffList" :key="staff.id"
									style="margin-bottom: 5px;">
									<el-radio :label="staff.id">
										{{staff.staff_name}}
									</el-radio>
								</el-col>
							</el-row>
						</el-radio-group>
						<el-checkbox-group v-model="staff_ids" v-if="type == 'checkbox'"
							@change="handleCheckboxChangeGroup(data.staffList)">
							<el-row style="width: 100%; margin-top: 10px;">
								<el-col :span="6" v-for="staff in data.staffList" :key="staff.id"
									style="margin-bottom: 5px;">
									<el-checkbox :label="staff.id" @change="handleCheckboxChange(staff)">
										{{staff.staff_name}}
									</el-checkbox>
								</el-col>
							</el-row>
						</el-checkbox-group>
						<hr />
					</div>
				</div>
			</el-tree>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['type', 'accordion', 'staff_id_prop', 'staff_ids_prop'],
		data() {
			return {
				//查询
				input: "",
				node: "",
				resolve: "",
				
				//单选框绑定值
				staff_id: [],
				//复选框绑定值
				staff_ids: [],

				//人员名称
				staff_name: "",
				//人员数据
				staff: [],

				//组织架构id
				organize_id: "",
				//组织架构名称
				organize_name: "",

				//数据展示字段
				defaultProps: {
					label: "organize_name",
					children: "organizeList",
				},
			}
		},
		methods: {
			//查询
			query(){
				this.node.childNodes = [];
				this.loadNode(this.node, this.resolve);
			},
			//懒加载
			async loadNode(node, resolve) {
				if (node.level === 0) {
					this.node = node;
					this.resolve = resolve;
					return resolve(await this.Find('', 'group'));
				} else {
					resolve(await this.Find(node.data.id, ''));
				}
			},
			//查询组织架构
			async Find(e, spare8) {
				var url = "organize/selectOrganizeStaff";
				var record = {
					organize_id: e == undefined ? '' : e,
					spare8: this.input != null && this.input != '' ? '' : spare8,
					staff_name: this.input
				};
				var result = [];
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						result = data;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}
				return result;
			},
			//选择节点
			nodeSelection(data, node) {
				this.organize_id = data.id;
				this.organize_name = data.organize_name;
			},
			//点击单选框
			handleRadioChange(staffList) {
				this.staff = [];
				staffList.some(item => {
					if (this.staff_id == item.id) {
						this.staff.push(item);
						this.staff_name = item.staff_name;
						return true;
					}
				})
			},
			//点击多选框组
			handleCheckboxChangeGroup(staffList) {
				if (this.$props["accordion"]) {
					var staff_ids = [];
					staffList.forEach(item => {
						if (this.staff_ids.indexOf(item.id) != -1) {
							staff_ids.push(item.id);
						}
					})
					this.staff_ids = staff_ids;
				}
			},
			//点击多选框
			handleCheckboxChange(staff) {

				var flag = false;
				this.staff_ids.some(item => {
					if (staff.id == item) {
						flag = true;
						return true;
					}
				})

				if (flag) {
					this.staff.push(staff);
					this.staff_name += staff.staff_name + ',';
				} else {
					this.staff.some((item, index) => {
						if (staff.id == item.id) {
							this.staff.splice(index, 1);
							return true;
						}
					})
					var staff_name = "";
					this.staff_name.split(',').forEach(item => {
						if (item != staff.staff_name) {
							staff_name += item + ',';
						}
					})
					this.staff_name = staff_name;
				}

			},
			//确定
			commit() {
				if (this.$props['type'] == 'checkbox') {
					this.staff_name = this.staff_name.substring(0, this.staff_name.length - 1);
				}
				var object = {
					staff_id: this.staff_id,
					staff_ids: this.staff_ids,
					staff_name: this.staff_name,
					staff: this.staff,
					organize_id: this.organize_id,
					organize_name: this.organize_name,
				}
				this.staff_ids = [] , 
				this.staff_name = "",
				this.$emit("commit", object);
			}
		},
		created() {},
		watch: {
			staff_id_prop(newValue) {
				this.staff_id = parseInt(newValue);
			},
			staff_ids_prop(newValue) {
				this.staff_ids = newValue;
			}
		}
	}
</script>

<style scoped="scoped">
	>>>.el-divider__text {
		font-size: 17px !important;
		font-weight: bold;
	}

	>>>.el-tree-node__content>div {
		width: 100%;
	}

	>>>.el-tree-node__content {
		height: 100%;
		width: 100%;
		margin-bottom: 20px;
	}

	>>>.el-tree-node__content>.el-tree-node__expand-icon {
		font-size: 15px;
	}

	>>>.el-radio-group {
		width: 100%;
	}

	>>>.el-checkbox-group {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// organizeStaff.vue?30fb06cd